import React, {Component} from 'react';
import {Translation} from 'react-i18next';

import RegistrationCodeForm from '../containers/RegistrationCodeFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class RegistrationCodeEditScreen extends Component {

  scrollToTop = () => {
    Logger.log('debug', `RegistrationCodeEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  }

  render() {
    return (
      <Translation>{(t) => 
        <div>
          <DocumentHead title={t('registration_code_route_edit')} />
          <RegistrationCodeForm id={this.props.match.params.id} />
        </div>
      }</Translation>
    )
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default RegistrationCodeEditScreen;

Logger.log('silly', `RegistrationCodeEditScreen loaded.`);
